import { Button } from "@mixitone/components";
import LinkIcon from "@mixitone/icons/link.svg";
import { ApplicationView } from "@mixitone/mvc";
import clsx from "clsx";
import React, { ReactNode } from "react";

interface Props {
  title: string;
  isActive: boolean;
  isCompleted: boolean;
  canOpen: boolean;
  onOpen: () => void;
  onNext?: () => void;
  showNextButton?: boolean;
  nextButtonText?: string;
  nextButtonDisabled?: boolean;
  children: ReactNode;
}

const AccordionSection: React.FC<Props> = ({
  title,
  isActive,
  isCompleted,
  canOpen,
  onOpen,
  onNext,
  showNextButton = false,
  nextButtonText = "Next",
  nextButtonDisabled = false,
  children,
}) => {
  return (
    <div className="mb-4 rounded-lg border border-gray-200">
      <div
        className={clsx("flex items-center justify-between rounded-t-lg p-4", {
          "cursor-pointer": canOpen && !isActive,
          "bg-slate-800 text-white": isActive,
          "bg-green-50": isCompleted && !isActive,
          "bg-slate-200": !isCompleted && !isActive,
        })}
        onClick={() => canOpen && onOpen()}
      >
        <div className="flex items-center">
          {isCompleted && !isActive && (
            <svg
              className="mr-2 h-5 w-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <h3 className="text-lg font-medium">{title}</h3>
        </div>
        {!isActive && canOpen && (
          <button type="button" className="text-blue-600 hover:text-blue-800" onClick={() => onOpen()}>
            <LinkIcon className="h-5 w-5" />
          </button>
        )}
      </div>
      {isActive && (
        <div className="bg-white p-4 shadow">
          {children}
          {showNextButton && onNext && (
            <div className="mt-4 flex justify-end">
              <Button
                type="button"
                kind="primary"
                className="text-lg"
                onClick={onNext}
                disabled={nextButtonDisabled}
              >
                {nextButtonText}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ApplicationView(AccordionSection);
